import { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiErr } from "@/lib/api";
import { FlaskConical, Loader2, ArrowLeft } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message);
      setSent(true);
    } catch (err) {
      setMsg(apiErr(err));
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-sm ss-fade-up">
        <div className="flex items-center gap-2 mb-8">
          <FlaskConical className="h-7 w-7 text-slate-900" />
          <span className="font-display font-bold text-xl text-slate-900">Science Sorted</span>
        </div>
        <h1 className="font-display text-2xl font-bold text-slate-900">Reset your password</h1>
        {sent ? (
          <p className="mt-4 text-slate-600" data-testid="forgot-confirmation">{msg}</p>
        ) : (
          <>
            <p className="mt-2 text-slate-500">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  required data-testid="forgot-email-input" className="mt-1.5 bg-white" />
              </div>
              <Button type="submit" disabled={busy} data-testid="forgot-submit-button"
                className="w-full bg-slate-900 hover:bg-slate-800 h-11">
                {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
              </Button>
            </form>
          </>
        )}
        <div className="mt-6">
          <Link to="/flashcards" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900">
            <ArrowLeft className="h-4 w-4" /> Back to login
          </Link>
        </div>
      </div>
    </div>
  );
}
